<!--
 * @Description: 对账联系函
 * @Autor: txp
 * @Date: 2021-05-07 11:28:36
-->
<template>
  <div class="reconciliation">
    <el-card class="box-card">
      <div class="mtb20 ft12 C787878">
        <span>服务中心：</span>
        <span
          ><a href="#" class="text-decoration_none themColor" @click="goBack"
            >返回上一页</a
          ></span
        >
        <span class="el-icon-arrow-right"></span>
        <span>收货</span>
      </div>
      <div class="">
        <span class="orderCode">订单编号：{{orderCode}}</span>
        <div v-loading="loading" style="min-height: 200px"  element-loading-spinner="el-icon-loading">
          <div v-if="theGoodsDetail.length>0">
             <TheGoodsItem @checkChange="goodsCheck" v-for="item in theGoodsDetail" :key="item.id" :detail="item"/>
          </div>
          <div class="cont" v-else-if="!loading">暂无...</div>
        </div>
          <div class="btn-container" v-if="theGoodsDetail.length>0">
            <el-button size="small" type="danger" @click="cancel">取消</el-button>
            <el-button size="small" type="primary" @click="determine">确定</el-button>
          </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex"; //主题的引用
import { getReceivingList,confirmReceipt } from "@/api/api";
import TheGoodsItem from './theGoodsitem.vue';
export default {
  name: "reconciliation",
  data() {
    return {
      orderCode: '',
      theGoodsDetail: [],
      selectDelivery: [],
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      theme: "theme",
    }),
  },
  components: {
    TheGoodsItem
  },
  created() {
    this.orderCode = this.$route.query.orderCode
    this.getReceivingList()
  },
  mounted() {
    
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.back()
    },
    /**
     * 取消
     */
    cancel() {
      this.goBack()
    },
    /**
     * 获取待收货列表
     */
    getReceivingList() {
      this.loading = true
      getReceivingList({orderCode: this.orderCode}).then((res)=>{
        this.theGoodsDetail = res.result
        this.loading =false
      })
    },
    /**
     * 获取选中商品
     */
    goodsCheck(val) {
      if(val.checked) {
        if(!this.selectDelivery.includes(val.deliveryCode)) {
          this.selectDelivery.push(val.deliveryCode)
        }
      }else {
         this.selectDelivery = this.selectDelivery.filter(item=>item!==val.deliveryCode)
      }
    },
    /**
     * 收货
     */
    determine() {
      confirmReceipt({
        orderCodes: [this.orderCode],
        deliveryCodes: this.selectDelivery
      }).then(()=>{
        this.$message.success('收货成功')
        this.$router.back()
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.reconciliation {
  height: 100%;
  // /deep/.el-card{
  //   height: 100%;
  // }
  .cont{
    margin-top: 20px;
    text-align: center;
  }
  .btn-container{
    padding: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
